import React, { useState } from "react";

// Lets a page take files dragged in from Finder. Safari keeps one remembered
// folder for every file dialog on the site, so dragging is how each page can
// stay on its own folder. The drop is always caught (even while disabled) so
// Safari doesn't leave the page to open the file.
export default function FileDropZone({ onFiles, disabled, hint, children }) {
  const [over, setOver] = useState(false);
  const enter = (e) => {
    e.preventDefault();
    if (!disabled) setOver(true);
  };
  return (
    <div
      onDragEnter={enter}
      onDragOver={enter}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        const files = Array.from(e.dataTransfer.files || []);
        if (!disabled && files.length) onFiles(files);
      }}
      style={{
        border: `2px dashed ${over ? "#6366f1" : "#cbd5e1"}`, borderRadius: 8, padding: 12,
        background: over ? "#eef2ff" : "transparent",
      }}
    >
      {children}
      <small style={{ display: "block", marginTop: 6, color: "#64748b" }}>
        {hint || "or drag a file here from Finder"}
      </small>
    </div>
  );
}
